export const getId = () => {
  return window.location.pathname.split("/")[1]
}
